export enum OrganizationsActionType {
	FETCH_ALL_USERS = 'FETCH_ALL_USERS',
	STORE_ALL_USERS = 'STORE_ALL_USERS',
	ERROR_STORE_ALL_USERS = 'ERROR_STORE_ALL_USERS',

	UPDATE_USER_STATUS = 'UPDATE_USER_STATUS',
	ADD_USER = 'ADD_USER',
	UPDATE_USER = 'UPDATE_USER',
	
	UPDATE_EMPLOYEE_DETAILS = 'UPDATE_EMPLOYEE_DETAILS',
	DELETE_EMPLOYEE = 'DELETE_EMPLOYEE',

	FETCH_ALL_DEPARTMENTS = 'FETCH_ALL_DEPARTMENTS',
	STORE_ALL_DEPARTMENTS = 'STORE_ALL_DEPARTMENTS',
	ERROR_STORE_ALL_DEPARTMENTS = 'ERROR_STORE_ALL_DEPARTMENTS',

	FETCH_ALL_DESIGNATIONS = 'FETCH_ALL_DESIGNATIONS',
	STORE_ALL_DESIGNATIONS = 'STORE_ALL_DESIGNATIONS',
	ERROR_STORE_ALL_DESIGNATIONS = 'ERROR_STORE_ALL_DESIGNATIONS',

	// Add Org Roles
	ADD_DESIGNATION = 'ADD_DESIGNATION',
	ERROR_ADD_DEPARTMENT = 'ERROR_ADD_DEPARTMENT',

	DELETE_DEPARTMENT = 'DELETE_DEPARTMENT',

	DELETE_DESIGNATION = 'DELETE_DESIGNATION',

	FETCH_MANAGER_AUTOCOMPLETE = 'FETCH_MANAGER_AUTOCOMPLETE',
	STORE_MANAGER_AUTOCOMPLETE = 'STORE_MANAGER_AUTOCOMPLETE',
	ERROR_MANAGER_AUTOCOMPLETE = 'ERROR_MANAGER_AUTOCOMPLETE',

	FETCH_USER_BY_ID = 'FETCH_USER_BY_ID',
	FETCH_ASSIGNED_PROJECTS = 'FETCH_ASSIGNED_PROJECTS'
}
